//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowDataSourceTestModeSync: FeatureFlag = {"Id":"ShowDataSourceTestModeSync","Label":"Show test data auto-sync toggle on data sources","Impact":"Allow enabling data sources to have a single set of rows instead of separate set of rows for test data and non-test data","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
